module.exports = __webpack_public_path__ + "img/26.2290004c.jpg";